import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { MemberDetails } from '../shared/interfaces/member-details';

@Injectable({
  providedIn: 'root'
})
export class MembersService {

  constructor(private apiService: ApiService) { }

  async getMemberInfo(memberId: string) {
    const response = await this.apiService.get<MemberDetails>('/api/strikemembers/details/' + memberId);
    const memberData : MemberDetails = {
      AddressUpdated: response.body.AddressUpdated,
      Address_1: response.body.Address_1,
      Address_2: response.body.Address_2,
      BirthDate: new Date(response.body.BirthDate),
      City: response.body.City,
      DebitCard: response.body.DebitCard,
      DebitCardInfo: response.body.DebitCardInfo,
      FirstName: response.body.FirstName,
      ID: response.body.ID,
      ImageExists: response.body.ImageExists,
      LastName: response.body.LastName,
      MemberId: response.body.MemberId,
      MemberName: response.body.MemberName,
      MiddleName: response.body.MiddleName,
      Phone: response.body.Phone,
      State: response.body.State,
      StrikeLine: response.body.StrikeLine,
      StrikeShift: response.body.StrikeShift,
      Zip: response.body.Zip,
    }

    return memberData;
  }

  async updateMemberInfo(member: MemberDetails) {
    const response = await this.apiService.post<MemberDetails>('/api/strikemembers/update', member);
    return response;
  }
}
